// import { Weight } from "lucide-react"
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { useMemo } from "react";

interface InfoItem {
  name: string;
  value: string | number;
}

interface WayBillCardProps {
  waybillNumber: string;
  infos: InfoItem[];
  label?: string;
  onLabel?: () => void;
}

export function WayBillCard({
  waybillNumber,
  infos,
  label,
  onLabel,
}: WayBillCardProps) {
  const maxLabelWidth = useMemo(() => {
    if (infos.length === 0) return 'auto';
    const maxLabelLength = Math.max(...infos.map(info => info.name.length));
    return `${maxLabelLength}ch`;
  }, [infos]);

  return (
    <div className="w-full flex justify-center">
      <Card className="w-full max-w-[25rem] min-h-[15.8rem] p-0 shadow-none border bg-[var(--waybillcard-bg)] border-[var(--waybillcard-border)] rounded-[var(--waybillcard-radius)]">
        <div className="px-[1.0875rem] flex flex-col min-h-[15.8rem]">
          <div className="pt-3 pb-[0.6875rem] text-lg font-semibold text-gray-800">
            运单号:{waybillNumber}
          </div>
          {/* 标题下分割线 */}
          <div
            className="border-b border-gray-200"
            style={{ borderStyle: "dashed" }}
          ></div>
          <div className="min-h-[8rem]">
            <table className="w-full border-collapse" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
              <tbody>
                {infos.map((info, index) => (
                  <tr key={index} className="h-7">
                    <td
                      className="whitespace-nowrap font-medium"
                      style={{ 
                        color: "var(--waybillcard-label-color)",
                        padding: '0.5rem 0.1rem 0.5rem 1rem',
                        width: maxLabelWidth,
                        flexShrink: 0
                      }}
                    >
                      {info.name}
                    </td>
                    <td
                      className="whitespace-nowrap font-medium"
                      style={{ 
                        color: "var(--waybillcard-label-color)",
                        padding: '0.5rem 0.5rem 0.5rem 0rem',
                        width: '20px',
                        textAlign: 'center'
                      }}
                    >
                      :
                    </td>
                    <td
                      className=""
                      style={{ 
                        color: "var(--waybillcard-content-color)",
                        padding: '0.5rem 0.5rem 0.5rem 0'
                      }}
                    >
                      {info.name === '联系电话' ? (
                        <a 
                          href={`tel:${info.value}`} 
                          className="text-blue-600 hover:text-blue-800 cursor-pointer"
                        >
                          {info.value}
                        </a>
                      ) : (
                        info.value
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* 按钮上方分割线 */}
          {label && (
            <div
              className="border-b border-gray-200"
              style={{ borderStyle: "dashed" }}
            ></div>
          )}

          {label && (
            <div className="flex justify-between pt-3 pb-[1.25rem] ">
              <Button
                variant="normal"
                className="rounded-full w-[7.625rem] text-base"
                onClick={onLabel}
              >
                {label}
              </Button>
              {/* <Button 
              variant="accent"
              className="rounded-full w-[7.625rem] shadow-sm text-base" 
              onClick={onConfirmOrder}
            >
              确认接单
            </Button> */}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}
